import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSetCreditLoading = IAction<EPaymentActions.SET_CREDIT_LOADING, boolean>;

const setCreditLoading = (isLoading: boolean): TSetCreditLoading => ({
    type: EPaymentActions.SET_CREDIT_LOADING,
    payload: isLoading,
});

export default setCreditLoading;
